import { FC, useMemo } from 'react'
import { useIntl } from 'react-intl'

import { MaritalStatusEnum } from '@models/base'
import { Option } from '@models/option'

import { SelectField, SelectFieldProps } from '@components/Form/Select'

type MaritalStatusEnumSelectProps = Omit<SelectFieldProps, 'options'>

export const MaritalStatusSelectField: FC<MaritalStatusEnumSelectProps> = (props) => {
  const intl = useIntl()

  const options: Array<Option> = useMemo(
    () => [
      new Option({
        label: intl.formatMessage({
          id: `enum.marital_status.${MaritalStatusEnum.SINGLE.toLowerCase()}`,
        }),
        value: MaritalStatusEnum.SINGLE,
      }),
      new Option({
        label: intl.formatMessage({
          id: `enum.marital_status.${MaritalStatusEnum.MARRIED.toLowerCase()}`,
        }),
        value: MaritalStatusEnum.MARRIED,
      }),
      new Option({
        label: intl.formatMessage({
          id: `enum.marital_status.${MaritalStatusEnum.DIVORCED.toLowerCase()}`,
        }),
        value: MaritalStatusEnum.DIVORCED,
      }),
      new Option({
        label: intl.formatMessage({
          id: `enum.marital_status.${MaritalStatusEnum.WIDOWED.toLowerCase()}`,
        }),
        value: MaritalStatusEnum.WIDOWED,
      }),
    ],
    // eslint-disable-next-line
    []
  )

  return (
    <SelectField
      {...props}
      options={options}
      noOptionsMessage={() => intl.formatMessage({ id: 'select.no_option' })}
    />
  )
}
